import { Injectable, NgZone } from '@angular/core';
import { StorageService } from './storage.service';
import { ApiService } from './api.service';
import { EventsService } from './events.service';
import { ToastService } from './toast.service';
import { MessageService } from './message.service';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	private controller = 'user/';
	user = null;

	constructor(
		public storageService: StorageService,
		private api: ApiService,
		private eventsService: EventsService,
		private zone: NgZone,
		public toastService: ToastService,
		public messageService: MessageService
	) {
		const channel = new BroadcastChannel('sw-messages');
		channel.onmessage = (event) => {
			this.zone.run(() => {
				// Processa a mensagem no Angular
				console.log('Mensagem recebida do SW:', event.data.payload);
				// this.toastService.show('danger', 'Mensagem recebida do SW');
				this.messageService.get().next(event.data.payload);
			});
		};
	}

	async init() {
		let user = await this.storageService.get('user');

		if (user) {
			document.documentElement.style.setProperty('--ion-color-primary', user.tourist_tax.color);
			this.api.setAuth(user.auth_key);
		}
	}

	view() {
		return this.api.get(this.controller + 'view');
	}

	change(id: string) {
		return this.api.post(this.controller + 'change', { id });
	}

	logout() {
		return this.api.post(this.controller + 'logout', null);
	}

	set(user: any) {
		this.user = user;
		this.storageService.set('user', user);
		this.eventsService.publish('update:user', user);
		const authkey = user ? user.auth_key : null;
		document.documentElement.style.setProperty('--ion-color-primary', user.tourist_tax.color);
		this.api.setAuth(authkey);
	}

	remove() {
		this.user = null;
		this.storageService.set('user', null);
		this.api.setAuth(null);
		this.eventsService.publish('user:logout');
	}

	setPassword(data: any) {
		return this.api.post(this.controller + 'set-password', data);
	}
}
